require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("regenerator-runtime/runtime");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React from "react";

/* global _NW_APP_BUILD_ */

/* eslint-disable    no-unused-expressions */
var mark = function mark(name) {
  window.performance && window.performance.mark && window.performance.mark(name);
}; // Mark the time at which the app's JS has been downloaded, parsed and begun to be evaluated


mark('nw-evaluate-app-javascript');

var measure = function measure(name, start, finish) {
  window.performance && window.performance.mark && window.performance.measure(name, start, finish);
};

var init = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var appConfig, isValidHostname, store, apolloClient, getApolloClient, apolloOptions, hot, redux, structuredContent, apollo, accessibility, render, rootEl, configureStore, initialState;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            /**
             * First things first:
             * If this app is being rendered on an external domain
             * (like google cache, the wayback machine, etc...)
             * Then don't render this app client-side at all.
             * This ensures that the SSR response is what the user sees
             * Client-side code running on 3rd party domains will have
             * issues properly rendering the page... For example,
             * on any app running on `react-router` (ALL of our apps at the moment)
             * The page content will disappear from the page after app boots client side
             * For the curious, the abyss starts here: https://github.com/ReactTraining/react-router/issues/5801
             */
            appConfig = require('@nerdwallet/app-config');
            isValidHostname = require('./isValidHostname');

            if (!(isValidHostname(window.location.hostname, appConfig.NERDWALLET_HOSTNAMES) === false)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return");

          case 4:
            if (!_NW_APP_BUILD_.__APOLLO__) {
              _context.next = 10;
              break;
            }

            getApolloClient = require('nw-app-build/alias-to/@nerdwallet/apollo/client')["default"];
            apolloOptions = require('nw-app-build/alias-to/apolloOptionsPath')["default"];
            _context.next = 9;
            return getApolloClient(apolloOptions);

          case 9:
            apolloClient = _context.sent;

          case 10:
            /**
             * This function will wrap the entry component with react hot reload
             */
            hot = function hot(children) {
              if (!_NW_APP_BUILD_.__HOT__) {
                return children;
              }

              var _require = require('nw-app-build/alias-to/react-hot-loader'),
                  AppContainer = _require.AppContainer;

              return /*#__PURE__*/React.createElement(AppContainer, null, children);
            };
            /**
             * This function will wrap the entry component with react-redux's <Provider />
             */


            redux = function redux(children) {
              if (!_NW_APP_BUILD_.__REDUX__) {
                return children;
              }

              var _require2 = require('nw-app-build/alias-to/react-redux'),
                  Provider = _require2.Provider;

              return /*#__PURE__*/React.createElement(Provider, {
                store: store
              }, children);
            };
            /**
             * This function will wrap the entry component with @nerdwallet/structured-content's <StructuredContentProvider />
             */


            structuredContent = function structuredContent(children) {
              if (!_NW_APP_BUILD_.__STRUCTURED_CONTENT__) {
                return children;
              }

              var _require3 = require('nw-app-build/alias-to/@nerdwallet/structured-content'),
                  StructuredContentProvider = _require3.StructuredContentProvider,
                  createClient = _require3.createClient; // sanity check that `@nerdwallet/structured-content` was available


              if (!StructuredContentProvider || !createClient) {
                throw new Error("@nerdwallet/structured-content dependency could not be loaded. Is it installed in your app's package.json file?");
              } // bootstrap StructuredContentProvider using the data supplied by nw-app-module's SSR render.


              var scClient = createClient({
                isomorphicState: window.__STRUCTURED_CONTENT_STATE__ // hardcoded as the same string in nw-app-module/server/render

              });
              return /*#__PURE__*/React.createElement(StructuredContentProvider, {
                client: scClient
              }, children);
            };
            /**
             * This function will wrap the entry component with apollo's <Provider /> and instantiate an apollo client
             */


            apollo = function apollo(children) {
              if (!_NW_APP_BUILD_.__APOLLO__) {
                return children;
              }

              var _require4 = require('@nerdwallet/apollo'),
                  ApolloProvider = _require4.ApolloProvider;

              return /*#__PURE__*/React.createElement(ApolloProvider, {
                client: apolloClient
              }, children);
            };
            /**
             * This function will wrap the entry component with @nerdwallet/react-accessibility-provider <SSRProvider />
             * This allows for autogenerated deterministic IDs from nw react component libraries
             */


            accessibility = function accessibility(children) {
              // @nerdwallet/react-accessibility-provider is guaranteed to be available by this this.
              // because if app hasn't installed it, and error was thrown during aliasing while bundling
              var _require5 = require('nw-app-build/alias-to/@nerdwallet/react-accessibility-provider'),
                  AccessibilitySSRProvider = _require5["default"];

              return /*#__PURE__*/React.createElement(AccessibilitySSRProvider, null, children);
            };
            /**
             * The render function -- bootstraps react with the requested wrappers into the DOM node specified in `reactRoot`
             */


            render = function render(rootEl) {
              /**
               * Grab the consuming app's default export. This will be a React component (or stateless functional compopnent)
               */
              var App = require('nw-app-build/alias-to/browserEntryPath');

              var ReactDOM = require('react-dom');

              App = App["default"] || App;
              var renderApp;

              if (_NW_APP_BUILD_.__SSR__) {
                // If SSR is enabled, try to hydrate if we're running on a version of
                // react-dom that supports it (>=16)
                renderApp = ReactDOM.hydrate || ReactDOM.render;
              } else {
                // If SSR is disabled, use `render` since there won't be a server-rendered
                // app to hydrate
                renderApp = ReactDOM.render;
              }

              renderApp(hot(accessibility(structuredContent(apollo(redux( /*#__PURE__*/React.createElement(App, {
                store: store
              })))))), rootEl);
            };

            rootEl = document.getElementById(_NW_APP_BUILD_.__REACT_ROOT__);

            if (_NW_APP_BUILD_.__REDUX__) {
              /**
               * Bootstrap redux store by looking for store state in the window object.
               * The reason this is within init is so that the store can be passed into
               * the render function and to the entry component in particular.
               */
              configureStore = require('nw-app-build/alias-to/configureStorePath');
              initialState = window[_NW_APP_BUILD_.__REDUX_STORE_KEY__]; // on the server, the 2nd and third params for configureStore are the express request and response

              store = (configureStore["default"] || configureStore)(initialState, undefined, undefined, {
                apolloClient: apolloClient
              });
            } // Mark the time prior to react render


            mark('nw-initial-react-render-start'); // Render it!

            render(rootEl); // Mark the time after react render. The app should be responsive after this

            mark('nw-initial-react-render-finish'); // Measure the delta between react render start and finish

            measure('nw-initial-react-render-duration', 'nw-initial-react-render-start', 'nw-initial-react-render-finish');

            if (_NW_APP_BUILD_.__HOT__) {
              module.hot.accept(require.resolve('nw-app-build/alias-to/browserEntryPath'), function () {
                render(rootEl);
              });
              /**
               * Only handle redux hot reloading if `redux` is enabled
               */

              if (_NW_APP_BUILD_.__REDUX__) {
                module.hot.accept(require.resolve('nw-app-build/alias-to/configureStorePath'), function () {
                  var reducers = require('nw-app-build/alias-to/reducersPath');

                  store.replaceReducer(reducers["default"] || reducers);
                });
              }
            }

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function init() {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Only initialize the app after dom content has been loaded
 */


if (document.readyState === 'interactive' || document.readyState === 'complete') {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init);
}